import { render, staticRenderFns } from "./MealPlanOrderDetail.vue?vue&type=template&id=52255b42&"
import script from "./MealPlanOrderDetail.vue?vue&type=script&lang=js&"
export * from "./MealPlanOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports